import "../../../filterValues/model/selectors/selectAllFilterValues.js";
import "../../../filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../filterValues/model/selectors/selectFilterItemByKey.js";
import { selectFilterItems } from "../../../filterValues/model/selectors/selectFilterItems.js";
import "../../../filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../filterValues/model/selectors/selectIsFilterValuesMissing.js";
import "react";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import "../../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import "../../../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import { createAppSelector } from "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import { prepareFilterHistoryItemValue } from "../../lib/prepareFilterHistoryItemValue.js";
import "../../../filterValues/api/api.js";
import "../../../filterValues/model/middleware/index.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../../shared/store/config/model/selectors/selectModels.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../../shared/store/config/model/slice.js";
import "../../../../shared/store/installation/model/slice.js";
import "../../../../shared/store/pagination/model/slice.js";
import "../middleware/index.js";
import "./selectFilterSortValue.js";
import "./selectFilterValuesCount.js";
import "./selectIsFilterValuesSelected.js";
import "./selectIsInitialSortValuesSelected.js";
import "./selectIsValidSortValuesSelected.js";
import { selectSlice } from "./selectSlice.js";
import "./selectSlugedFilterValues.js";
import "../slice.js";
const selectFilterHistory = createAppSelector([selectSlice, selectFilterItems], (choice, filterItems) => {
  const extendedHistoryItems = choice.history.reduce((acc, historyItem) => {
    const extHistoryItemValue = prepareFilterHistoryItemValue(historyItem, filterItems);
    if (!extHistoryItemValue) {
      return acc;
    }
    return [...acc, extHistoryItemValue];
  }, []);
  return extendedHistoryItems;
});
export {
  selectFilterHistory
};
